import React from "react";

const numberFormat = new Intl.NumberFormat("en-US");

function TruckIcon() {
  return (
    <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2.5 5.5h11v10h-11z" />
      <path d="M13.5 9h4l3.5 3.5v3h-7.5" />
      <circle cx="6.5" cy="17.5" r="2" style={{ fill: "var(--stat-icon-bg)" }} />
      <circle cx="17" cy="17.5" r="2" style={{ fill: "var(--stat-icon-bg)" }} />
    </svg>
  );
}

function TrendUpIcon() {
  return (
    <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 17l6-6 4 4 8-8" />
      <path d="M15 7h6v6" />
    </svg>
  );
}

function BoxesIcon() {
  return (
    <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinejoin="round">
      <rect x="8" y="3" width="8" height="7" rx="1" />
      <rect x="3" y="12" width="8" height="8" rx="1" />
      <rect x="13" y="12" width="8" height="8" rx="1" />
      <path d="M11 3v3M5.5 12v3M17 12v3" strokeLinecap="round" />
    </svg>
  );
}

function InfoIcon() {
  return (
    <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="10" cy="10" r="8" />
      <path d="M10 9v5" strokeLinecap="round" />
      <circle cx="10" cy="6.2" r="0.6" fill="currentColor" />
    </svg>
  );
}

function StatCard({ tone, icon, label, info, value, subLabel, loading }) {
  return (
    <div className={`inv-stat-card inv-stat-card--${tone}`}>
      <div className="inv-stat-card-inner">
        <div className="inv-stat-icon">{icon}</div>
        <div className="inv-stat-content">
          <div className="inv-stat-label">
            <span>{label}</span>
            <span className="inv-stat-info" tabIndex={0} aria-label={info} data-tip={info}>
              <InfoIcon />
            </span>
          </div>
          {loading ? (
            <span className="inv-stat-value-skeleton" aria-hidden="true" />
          ) : (
            <p className="inv-stat-value">{value}</p>
          )}
          <p className="inv-stat-sub">{subLabel}</p>
        </div>
      </div>
    </div>
  );
}

/** Presentational — data comes from the summary API via the parent. */
export default function InventoryStatCards({ data, loading, error, onRetry }) {

  const fmt = (n) => (data ? numberFormat.format(n) : "—");
  const assigned = data?.onboardedVehicles ?? 0;
  const unassigned = data?.unonboardedVehicles ?? 0;

  const cards = [
    {
      tone: "blue",
      icon: <TruckIcon />,
      label: "Total Purchase",
      info: "All vehicles purchased — assigned plus unassigned.",
      value: fmt(assigned + unassigned),
      subLabel: "Assigned + Unassigned",
    },
    {
      tone: "green",
      icon: <TrendUpIcon />,
      label: "Total Sales (Assigned)",
      info: "Vehicles onboarded and assigned to a customer.",
      value: fmt(assigned),
      subLabel: "Vehicles with Customer",
    },
    {
      tone: "amber",
      icon: <BoxesIcon />,
      label: "Total Inventory (Unassigned)",
      info: "Vehicles not yet onboarded / assigned to a customer.",
      value: fmt(unassigned),
      subLabel: "Vehicles without Customer",
    },
  ];

  return (
    <div className="inv-stat-section">
      {error && (
        <div className="inv-stat-error">
          <span>Couldn't load vehicle summary: {error}</span>
          <button type="button" onClick={onRetry}>Retry</button>
        </div>
      )}
      <div className="inv-stat-grid">
        {cards.map((card) => (
          <StatCard key={card.label} {...card} loading={loading && !data} />
        ))}
      </div>
    </div>
  );
}
